import produce, { Draft } from "immer";
import { combineReducers } from "redux";

import { ACTIONS, ActionType } from "actions/requests/types";
import { CreateRequest, UserRequests, AvailableIssueTypes, RequestComments } from "./types";
import { LoadingState } from "types/api";

const initialUserRequests = {
    data: null,
    status: LoadingState.idle,
    nextPageUrl: false
};

const initialRequestComments = {
    data: null,
    status: LoadingState.idle,
    nextPageUrl: false
};

const initialAvailableIssueTypes = {
    data: null,
    status: LoadingState.idle,
};

const initialCreateRequest = {
    status: LoadingState.idle,
};

export const initialState = {
    userRequests: initialUserRequests,
    createRequest: initialCreateRequest,
    availableIssueTypes: initialAvailableIssueTypes,
    requestComments: initialRequestComments
};


const requestComments = produce((state: Draft<RequestComments>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.GET_REQUEST_COMMENTS_REQUEST:
            state.status = LoadingState.loading;
            break;
        case ACTIONS.GET_REQUEST_COMMENTS_SUCCESS: {
            state.status = LoadingState.success;
            state.data = action.payload.comments;
            state.isNextPage = action.payload.isNextPage;
            break;
        }
        case ACTIONS.GET_REQUEST_COMMENTS_FAILURE:
            state.status = LoadingState.idle;
            break;
    }
}, initialRequestComments);


const userRequests = produce((state: Draft<UserRequests>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.GET_REQUESTS_REQUEST:
            state.status = LoadingState.loading;
            break;
        case ACTIONS.GET_REQUESTS_SUCCESS: {
            state.status = LoadingState.success;
            state.data = action.payload.userRequests;
            state.isNextPage = action.payload.isNextPage;
            break;
        }
        case ACTIONS.CREATE_REQUEST_SUCCESS:
            if (state.data) {
                state.data.unshift(action.payload);
            }
            break;
    }
}, initialUserRequests);

const availableIssueTypes = produce((state: Draft<AvailableIssueTypes>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.GET_AVAILABLE_ISSUE_TYPES_REQUEST:
            state.status = LoadingState.loading;
            break;
        case ACTIONS.GET_AVAILABLE_ISSUE_TYPES_SUCCESS: {
            state.status = LoadingState.success;
            state.data = action.payload.map(requestType => {
                return {
                    value: requestType.value,
                    label: requestType.name,
                };
            });
            break;
        }
    }
}, initialAvailableIssueTypes);

const createRequest = produce((state: Draft<CreateRequest>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.CREATE_REQUEST_REQUEST:
            state.status = LoadingState.loading;
            break;
        case ACTIONS.CREATE_REQUEST_SUCCESS: {
            state.status = LoadingState.success;
            break;
        }
        case ACTIONS.CREATE_REQUEST_FAILURE:
            state.status = LoadingState.idle;
            break;
    }
}, initialCreateRequest);

const requests = combineReducers({
    userRequests,
    availableIssueTypes,
    createRequest,
    requestComments
});

export default requests;
